import { render, staticRenderFns } from "./settlementBillDetail.vue?vue&type=template&id=770b47a3&scoped=true"
import script from "./settlementBillDetail.vue?vue&type=script&lang=js"
export * from "./settlementBillDetail.vue?vue&type=script&lang=js"
import style0 from "./settlementBillDetail.vue?vue&type=style&index=0&id=770b47a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770b47a3",
  null
  
)

export default component.exports